// import React, { useEffect, useState } from "react";
// import {
//   MdKeyboardArrowDown,
//   MdKeyboardArrowUp,
//   MdOutlineDashboard,
// } from "react-icons/md";
// import { AiOutlineBarChart } from "react-icons/ai";
// import { BiBriefcase } from "react-icons/bi";
// import { useHistory } from "react-router-dom";

// import classes from "./SideMenuData.module.css";

// const SideMenuData = (props) => {
//   const [expandedMenu, setExpandedMenu] = useState();
//   const history = useHistory();

//   const redirectToPageHandler = (url, index) => {
//     if (url) {
//       history.push(url);
//       props.sideMenuClose(true);
//     } else {
//       if (expandedMenu === index) {
//         setExpandedMenu("");
//         return;
//       }
//       setExpandedMenu(index);
//     }
//   };

//   return (
//     <React.Fragment>
//       {props.menu.map((menu, index) => {
//         return (
//           <React.Fragment>
//             <div
//               // className={classes.menu}

//               className={classes.sideMenuContainer}
//               style={{
//                 display: "flex",
//                 // marginTop: "16px",
//                 padding: "10px",
//                 alignItems: "center",
//               }}
//             >
//               {/* {props.iconFlag && (
//                 <MdOutlineDashboard className={classes.frontIcons} />
//               )} */}
//               {props.iconFlag && menu.icon && (
//                 <img
//                   src={menu.icon}
//                   alt={`${menu.name} icon`}
//                   className={classes.frontIcons}
//                   style={{ width: "22px", height: "22px" }}
//                 />
//               )}

//               <div
//                 className={classes.mainMenuContainer}
//                 onClick={() => redirectToPageHandler(menu.url, index)}
//               >
//                 <div className={classes.mainMenu}>
//                   {menu.name
//                     ? menu.name
//                     : menu.main.charAt(0).toUpperCase() +
//                       menu.main.slice(1).toLowerCase()}
//                 </div>
//                 {menu.sub && (
//                   <div className={classes.dropIcons}>
//                     {index === expandedMenu ? (
//                       <MdKeyboardArrowUp />
//                     ) : (
//                       <MdKeyboardArrowDown />
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//             {menu.sub && index === expandedMenu && (
//               <div style={{ marginLeft: "30px" }}>
//                 <SideMenuData
//                   menu={menu.sub}
//                   sideMenuClose={props.sideMenuClose}
//                   iconFlag={true}
//                 />
//               </div>
//             )}
//           </React.Fragment>
//         );
//       })}
//     </React.Fragment>
//   );
// };

// export default SideMenuData;

import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useHistory } from "react-router-dom";
import classes from "./SideMenuData.module.css";
import { usePageTitle } from "../../Context/PageTitleContext";

const SideMenuData = (props) => {
  const [expandedMenu, setExpandedMenu] = useState();
  const history = useHistory();
  const { setPageTitle } = usePageTitle();

  const redirectToPageHandler = (url, index, menuName) => {
    if (url) {
      // Set the page title based on menu name
      const title = menuName
        ? menuName
        : props.menu[index]?.main
        ? props.menu[index].main.charAt(0).toUpperCase() +
          props.menu[index].main.slice(1).toLowerCase()
        : "";
      setPageTitle(title);
      history.push(url);
      props.sideMenuClose(true);
    } else {
      if (expandedMenu === index) {
        setExpandedMenu("");
      } else {
        setExpandedMenu(index);
      }
    }
  };

  return (
    <React.Fragment>
      {props.menu.map((menu, index) => (
        <React.Fragment key={index}>
          <div
            className={classes.menuItem}
            onClick={() => redirectToPageHandler(menu.url, index, menu.name)}
          >
            {props.iconFlag && menu.icon && (
              <img
                src={menu.icon}
                alt={`${menu.name} icon`}
                className={classes.frontIcons}
              />
            )}

            <div className={classes.mainMenuContainer}>
              <div className={classes.mainMenu}>
                {menu.name
                  ? menu.name
                  : menu.main.charAt(0).toUpperCase() +
                    menu.main.slice(1).toLowerCase()}
              </div>
              {menu.sub && (
                <div className={classes.dropIcons}>
                  {index === expandedMenu ? (
                    <MdKeyboardArrowUp />
                  ) : (
                    <MdKeyboardArrowDown />
                  )}
                </div>
              )}
            </div>
          </div>

          {menu.sub && index === expandedMenu && (
            <div className={classes.subMenuWrapper}>
              <SideMenuData
                menu={menu.sub}
                sideMenuClose={props.sideMenuClose}
                iconFlag={true}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default SideMenuData;
